/**
 * Created by gavin on 19/2/15.
 */
import axios from "../../utils/axios";

// 国家列表
export function getList(query) {
    return axios({
        url: "/mbcount/getList",
        method: "get",
        params: query
    });
}
//更改状态
export function editStatus(data) {
    return axios({
        url: "/mbcount/editStatus",
        method: "post",
        data: data
    });
}
